import { getPage } from "../shared/global";
import reporter from "../report/reporter";
/**
 * 切换旧版本
 * @param {Element} targetNode
 */
export function switch_version(targetNode) {
  const page = getPage();

  const trackData = {
    event_id: 39008,
    event_name: "button_click",
    button_name: targetNode.getAttribute("data-button-name"),
    ...page,
  };

  reporter(trackData);
}
